<div class="row m-0 h-100">
  <div class="form p-10" *ngIf="!isDisabled" [ngClass]="{ 'private-background': activeDocumentTab == 1 }">
    <div class="form-section">
      <div class="form-section-documents justify-content-between" *ngIf="existingDocuments"
        [ngClass]="{ 'private-background': activeDocumentTab == 1 }">
        <label class="form-label">{{
          "forms.labels.exist_documents_" + label | translate
          }} <a class="goDocs" (click)="downloadAllDocuments()" *ngIf="activeForm =='doc-order'"> <span
              class="goDocs">{{
              "forms.labels.download_all"| translate
              }}</span></a></label>
        <div (click)="showExistingDocuments = !showExistingDocuments" class="clickable">
          <i class="" [ngClass]="{
              'icon-chevron-up': showExistingDocuments,
              'icon-chevron-down': !showExistingDocuments
            }"></i>
        </div>
      </div>

      <div class="form-section-documents justify-content-end" *ngIf="existingDocuments"
        [ngClass]="{ 'private-background': activeDocumentTab == 1 }">
        <label class="form-label orderDocs">{{ "forms.labels.order_document_by" | translate }}
          <a class="orderDocs" [ngClass]="{ 'desactivate': orderDocumentType !='type'  }" (click)="orderDocs('type')">
            {{"forms.labels.type"| translate }}</a> |
          <a class="orderDocs" [ngClass]="{ 'desactivate': orderDocumentType !='date_asc'  }"
            (click)="orderDocs('date_asc')">
            {{"forms.labels.date_asc"| translate }}</a> |
          <a class="orderDocs" [ngClass]="{ 'desactivate': orderDocumentType !='date_desc'  }"
            (click)="orderDocs('date_desc')">
            {{"forms.labels.date_desc"| translate }}</a></label>

      </div>

      <!-- Lista de documentos existentes -->
      <ul *ngIf="showExistingDocuments" [ngClass]="{ 'private-background': activeDocumentTab == 1 }">
        <div class="form-section-documents" *ngFor="let existingDocument of existingDocuments"
          [ngClass]="{ 'private-background': activeDocumentTab == 1 }">
          <a [href]="existingDocument.file" [download]="existingDocument.name" target="_blank">
            <li class="existDocument">
              <img class="thumbnail" [src]="getThumbnailSrc2(existingDocument.name)" alt="Thumbnail" />
              <i class="icon-download2"></i>
              <div class="type" [ngStyle]="{'background-color': pickAColor(existingDocument.type)}">{{
                "select.document_type." + existingDocument.type | translate }}</div>
              {{ existingDocument.name + " "}} <span class="secondary-text"> ({{ existingDocument.created_at | date:
                'dd/MM/yyyy HH:mm' }}) </span>
            </li>
          </a>
        <!--   <span class='trash'
            *ngIf="account_type == 'broker' || (activeForm == 'doc-order' && account_type == 'supplier' )"
            (click)="deleteFile(existingDocument.reference)">
            <i class="icon-trash"></i>
          </span> -->
        </div>
      </ul>
    </div>
  </div>
